/* Waco Diamonds - Engagement Rings collection behavior. Loaded ONLY on the
   collection.engagement-rings template.

   Style tiles filter the rendered grid CLIENT-SIDE by the card's style attribute
   (data-waco-shank = band style, data-waco-setting = setting style). This works regardless of
   which Search & Discovery filters are configured and never dead-ends to "No products found".
   The template renders all parents on one page (product_limit 48) so client-side filtering is
   complete. Also: in-collection search, native applied-filter chips (for real S&D facets like
   Price), and a friendly empty state. Re-runs after facets AJAX / infinite scroll. */
(function () {
  "use strict";
  if (window.__wacoEngCollection) return;
  window.__wacoEngCollection = true;

  var STYLE_PARAM = "style";

  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function gridContainer() { return $("#ProductGridContainer") || $(".product-grid__wrapper"); }

  var activeStyles = []; // selected style VALUES (unique across band/setting); [] = no filter

  // Styles are stored in the URL as a comma-separated list: ?style=Prong,Pavé
  function readStyleFromUrl() {
    var params = new URLSearchParams(window.location.search || "");
    var raw = params.get(STYLE_PARAM) || "";
    activeStyles = raw.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function writeStyleToUrl() {
    var params = new URLSearchParams(window.location.search || "");
    if (activeStyles.length) params.set(STYLE_PARAM, activeStyles.join(",")); else params.delete(STYLE_PARAM);
    var qs = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (qs ? "?" + qs : "") + window.location.hash);
  }

  // ---------- combined filtering (style + search) ----------
  // Multiple styles are OR-ed: a card shows if it matches ANY selected value. We match against
  // the card's band style, setting style AND diamond shape, so the same code drives both the
  // "Shop by Style" (shank/setting) and "Shop by Shape" (shape) tile sets — the tile value is
  // unique to one attribute, so there is no cross-collision.
  function cardMatchesStyle(card) {
    if (!activeStyles.length) return true;
    var shank = card.getAttribute("data-waco-shank");
    var setting = card.getAttribute("data-waco-setting");
    var shape = card.getAttribute("data-waco-shape");
    return activeStyles.indexOf(shank) !== -1 ||
           activeStyles.indexOf(setting) !== -1 ||
           activeStyles.indexOf(shape) !== -1;
  }
  function cardText(card) {
    var t = card.querySelector(".card-product-content__title");
    var sub = card.querySelector(".card-product-content__subtitle, .card__interactive.caption");
    return ((t ? t.textContent : "") + " " + (sub ? sub.textContent : "")).toLowerCase();
  }
  function currentSearchTerm() {
    var input = $("[data-waco-search-input]");
    return input ? input.value.trim().toLowerCase() : "";
  }
  function applyFilters() {
    var term = currentSearchTerm();
    var lis = $all("#ProductGrid > li");
    var shown = 0;
    lis.forEach(function (li) {
      var card = li.querySelector(".card-product") || li;
      var ok = cardMatchesStyle(card) && (!term || cardText(card).indexOf(term) !== -1);
      li.classList.toggle("waco-card-hidden", !ok);
      if (ok) shown++;
    });
    updateResultsCount(shown, lis.length);
    updateEmptyState(shown);
  }

  function isFiltering() { return activeStyles.length > 0 || !!currentSearchTerm(); }

  // Keep the native results count honest while we filter client-side: the native ".facets__results"
  // ("48 of 48 products") reflects the SERVER set, which is wrong once a style tile or search hides
  // cards. Show the true visible count while filtering; restore the native text when cleared.
  function updateResultsCount(shown, total) {
    var el = $(".facets__results");
    var text = null;
    if (el) {
      var filtering = isFiltering();
      if (filtering) {
        if (!el.hasAttribute("data-waco-orig")) el.setAttribute("data-waco-orig", el.textContent);
        var orig = el.getAttribute("data-waco-orig");
        // Preserve the native phrasing/localization ("Results: 48 of 48 products") and just swap the
        // leading count to the true visible number -> "Results: 24 of 48 products".
        text = /\d/.test(orig) ? orig.replace(/\d[\d,]*/, String(shown)) : "Results: " + shown + " of " + total + " products";
        el.textContent = text;
      } else if (el.hasAttribute("data-waco-orig")) {
        el.textContent = el.getAttribute("data-waco-orig");
        el.removeAttribute("data-waco-orig");
        text = el.textContent;
      } else {
        text = el.textContent;
      }
    }
    if (text == null) text = "Results: " + shown + " of " + total + " products";
    // The native .facets__results renders only inside the (desktop) filter sidebar, which is
    // removed on this collection — so it never shows on mobile. Mirror the count into our own
    // element (shown < 750px; desktop keeps the native count) so mobile always has a count.
    var mob = ensureMobileCount();
    if (mob) mob.textContent = text.trim();
  }
  function ensureMobileCount() {
    var c = $(".waco-results-count");
    if (c) return c;
    var container = gridContainer();
    if (!container || !container.parentNode) return null;
    c = document.createElement("div");
    c.className = "waco-results-count";
    container.parentNode.insertBefore(c, container);
    return c;
  }

  function updateEmptyState(shown) {
    var grid = $("#ProductGrid");
    if (!grid) return;
    var msg = $(".waco-empty-state");
    var filtering = isFiltering();
    if (shown === 0 && filtering) {
      if (!msg) {
        msg = document.createElement("div");
        msg.className = "waco-empty-state";
        grid.parentNode.insertBefore(msg, grid.nextSibling);
      }
      msg.innerHTML = 'No rings match those choices. <button type="button" class="waco-empty-state__clear" data-waco-clear-all>Clear filters</button>';
    } else if (msg) {
      msg.remove();
    }
  }

  // ---------- style tiles ----------
  function markTiles() {
    $all("[data-waco-tile]").forEach(function (tile) {
      var on = activeStyles.indexOf(tile.getAttribute("data-waco-tile-value")) !== -1;
      tile.classList.toggle("is-active", on);
      tile.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }
  function allTileValues() {
    var seen = {}, out = [];
    $all("[data-waco-tile]").forEach(function (t) {
      var v = t.getAttribute("data-waco-tile-value");
      if (v && !seen[v]) { seen[v] = 1; out.push(v); }
    });
    return out;
  }
  // Multi-select: tapping a tile adds/removes its style. When EVERY tile ends up selected we
  // revert to no filter (show the whole collection) rather than an all-inclusive OR.
  function toggleStyle(value) {
    var i = activeStyles.indexOf(value);
    if (i === -1) activeStyles.push(value); else activeStyles.splice(i, 1);
    var all = allTileValues();
    if (all.length && all.every(function (v) { return activeStyles.indexOf(v) !== -1; })) activeStyles = [];
    writeStyleToUrl();
    refresh();
  }
  function removeStyle(value) {
    var i = activeStyles.indexOf(value);
    if (i !== -1) activeStyles.splice(i, 1);
    writeStyleToUrl();
    refresh();
  }

  // ---------- applied chips (native S&D facets + the active style) ----------
  function money(n) { return "$" + Math.round(parseFloat(n)).toLocaleString("en-US"); }
  function chipLabel(key, value) {
    if (key === "filter.v.price.gte") return "From " + money(value);
    if (key === "filter.v.price.lte") return "Up to " + money(value);
    return value;
  }
  function removalSearch(params, key, value) {
    var next = new URLSearchParams();
    params.forEach(function (v, k) { if (!(k === key && v === value)) next.append(k, v); });
    return next.toString();
  }
  function renderChips() {
    var container = gridContainer();
    if (!container) return;
    var params = new URLSearchParams(window.location.search || "");
    var nativeActive = [];
    params.forEach(function (v, k) { if (k.indexOf("filter.") === 0) nativeActive.push([k, v]); });

    var host = $(".waco-applied-chips");
    var hasAny = nativeActive.length || activeStyles.length;
    if (!hasAny) { if (host) host.remove(); return; }
    if (!host) {
      host = document.createElement("ul");
      host.className = "waco-applied-chips";
      host.setAttribute("role", "list");
      container.parentNode.insertBefore(host, container);
    }
    var html = "";
    activeStyles.forEach(function (style) {
      html += '<li><button type="button" class="waco-applied-chip" data-waco-clear-style data-waco-style-value="' +
        style.replace(/"/g, "&quot;") + '">' +
        "<span>" + style + "</span><span class=\"waco-applied-chip__x\" aria-hidden=\"true\">&times;</span>" +
        '<span class="visually-hidden">Clear style</span></button></li>';
    });
    nativeActive.forEach(function (pair) {
      var qs = removalSearch(params, pair[0], pair[1]);
      var href = window.location.pathname + (qs ? "?" + qs : "");
      html += '<li><a class="waco-applied-chip" href="' + href + '"><span>' + chipLabel(pair[0], pair[1]) +
        '</span><span class="waco-applied-chip__x" aria-hidden="true">&times;</span>' +
        '<span class="visually-hidden">Remove filter</span></a></li>';
    });
    html += '<li><button type="button" class="waco-applied-chip waco-applied-chip--clear" data-waco-clear-all>Clear all</button></li>';
    host.innerHTML = html;
  }

  function clearAll() {
    activeStyles = [];
    var params = new URLSearchParams(window.location.search || "");
    var keep = new URLSearchParams();
    params.forEach(function (v, k) { if (k.indexOf("filter.") !== 0 && k !== STYLE_PARAM) keep.append(k, v); });
    var input = $("[data-waco-search-input]");
    if (input) { input.value = ""; var c = $(".waco-collection-search__clear"); if (c) c.hidden = true; }
    var qs = keep.toString();
    // if there were native filters in the URL, navigate to drop them; else stay (client-side clear).
    var hadNative = false;
    params.forEach(function (v, k) { if (k.indexOf("filter.") === 0) hadNative = true; });
    if (hadNative) { window.location.href = window.location.pathname + (qs ? "?" + qs : ""); return; }
    window.history.replaceState({}, "", window.location.pathname + (qs ? "?" + qs : "") + window.location.hash);
    refresh();
  }

  // ---------- in-collection search ----------
  // Guard per-node (not a module flag) so a search input that gets recreated after a native
  // re-render is always wired, and moving the node between the tiles bar and the facets row
  // (which preserves its listeners) never double-binds.
  function wireSearch(input) {
    if (!input || input.__wacoWired) return;
    input.__wacoWired = true;
    var wrap = input.closest(".waco-collection-search");
    var clear = wrap ? wrap.querySelector(".waco-collection-search__clear") : null;
    input.addEventListener("input", function () { if (clear) clear.hidden = !input.value; applyFilters(); });
    if (clear) clear.addEventListener("click", function () { input.value = ""; clear.hidden = true; applyFilters(); input.focus(); });
  }
  function ensureSearch() {
    // The search input is rendered in the style-tiles bar (right of the tiles on desktop,
    // full-width under them on mobile). Bind to it. Fallback: if it's missing (e.g. a native
    // re-render orphaned the node), inject a fresh one above the grid.
    var input = $("[data-waco-search-input]");
    if (input) { wireSearch(input); return; }
    var container = gridContainer();
    if (!container) return;
    var wrap = document.createElement("div");
    wrap.className = "waco-collection-search";
    wrap.innerHTML =
      '<svg class="waco-collection-search__icon" viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><circle cx="9" cy="9" r="6" fill="none" stroke="currentColor" stroke-width="1.6"/><line x1="13.5" y1="13.5" x2="18" y2="18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      '<input type="search" class="waco-collection-search__input" placeholder="Search this collection" aria-label="Search this collection" data-waco-search-input>' +
      '<button type="button" class="waco-collection-search__clear" aria-label="Clear search" hidden>&times;</button>';
    container.parentNode.insertBefore(wrap, container);
    wireSearch(wrap.querySelector("[data-waco-search-input]"));
  }

  // ---------- refresh ----------
  function refresh() {
    ensureSearch();
    renderChips();
    markTiles();
    applyFilters();
  }

  // delegated events
  document.addEventListener("click", function (e) {
    var tile = e.target.closest && e.target.closest("[data-waco-tile]");
    if (tile) { e.preventDefault(); toggleStyle(tile.getAttribute("data-waco-tile-value")); return; }
    var chip = e.target.closest && e.target.closest("[data-waco-clear-style]");
    if (chip) { e.preventDefault(); removeStyle(chip.getAttribute("data-waco-style-value")); return; }
    if (e.target.closest && e.target.closest("[data-waco-clear-all]")) { e.preventDefault(); clearAll(); return; }
  });

  // Client-side style/search filtering needs EVERY product in the DOM. The collection paginates
  // (product_limit) with native infinite scroll, which only loads on scroll-intersection - so a
  // shopper who filters before scrolling would miss later pages. Pull the remaining pages up front
  // DETERMINISTICALLY by fetching each next page and appending its cards (no scroll/IO reliance).
  // Small catalog (~48) => 1 extra fetch. The card style attributes come in the HTML, so filtering
  // is immediately complete; global swatch handling + our observer re-init appended cards.
  // The native infinite-scroll component rewrites/removes the load-more anchor on load (it loads
  // on scroll-intersection), so we can't read it. Instead fetch the stable ?page=N URLs directly
  // and append their cards until a page returns none. Preserve sort + native facet params; strip
  // our client-side `style` param. Dedupe by product link so nothing doubles up.
  function productKey(li) {
    var a = li.querySelector("a[href*='/products/']");
    return a ? (a.getAttribute("href") || "").split("?")[0] : null;
  }
  function seenKeys() {
    var set = {};
    $all("#ProductGrid > li").forEach(function (li) { var k = productKey(li); if (k) set[k] = true; });
    return set;
  }
  function sectionId() { var g = $("#ProductGrid"); return g ? g.getAttribute("data-id") : null; }
  function currentPage() {
    var p = parseInt(new URLSearchParams(window.location.search || "").get("page"), 10);
    return p > 1 ? p : 1;
  }
  function stripPageParam() {
    var params = new URLSearchParams(window.location.search || "");
    if (!params.has("page")) return;
    params.delete("page");
    var qs = params.toString();
    window.history.replaceState({}, "", window.location.pathname + (qs ? "?" + qs : "") + window.location.hash);
  }
  // Fetch one page's product <li>s via the Section Rendering API (light - just the section HTML).
  function fetchPageCards(n) {
    var sid = sectionId();
    var params = new URLSearchParams(window.location.search || "");
    params.delete(STYLE_PARAM);
    params.delete("page");
    if (sid) params.set("section_id", sid);
    params.set("page", String(n));
    return fetch(window.location.pathname + "?" + params.toString(), { headers: { "X-Requested-With": "XMLHttpRequest" }, credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        if (!t) return [];
        var g = new DOMParser().parseFromString(t, "text/html").querySelector("#ProductGrid");
        return g ? Array.prototype.filter.call(g.children, function (li) { return productKey(li); }) : [];
      })
      .catch(function () { return []; });
  }
  function appendCards(lis) {
    var grid = $("#ProductGrid");
    if (!grid) return 0;
    var seen = seenKeys();
    var added = 0;
    lis.forEach(function (li) { var k = productKey(li); if (k && seen[k]) return; grid.appendChild(document.importNode(li, true)); added++; });
    if (added) refresh();
    return added;
  }
  function loadFrom(n) {
    if (n > 20) return; // safety cap
    fetchPageCards(n).then(function (lis) {
      if (!lis.length) { refresh(); return; } // past the last page
      appendCards(lis);
      loadFrom(n + 1);
    });
  }
  // Load EVERY product up front so client-side filtering is complete and correctly ordered.
  // If the page loaded at ?page>1 (native infinite scroll writes ?page= to the URL on scroll),
  // rebuild the grid from page 1 first so nothing is missing or out of order.
  function ensureAllLoaded() {
    var start = currentPage();
    stripPageParam();
    if (start > 1) {
      fetchPageCards(1).then(function (lis) {
        var grid = $("#ProductGrid");
        if (grid && lis.length) {
          grid.innerHTML = "";
          lis.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          refresh();
        }
        loadFrom(2);
      });
    } else {
      loadFrom(2);
    }
  }

  function init() {
    if (!$("#ProductGrid") && !$("[data-waco-style-tiles]")) return;
    readStyleFromUrl();
    refresh();
    ensureAllLoaded();
    var container = gridContainer();
    if (container && window.MutationObserver) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; refresh(); });
      }).observe(container, { childList: true, subtree: true });
    }
    window.addEventListener("popstate", function () { readStyleFromUrl(); refresh(); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
